var open = new Set();
export default {
    /**
     * Mark a popup as open.
     * @param id
     */
    add: function(id) {
        open.add(id);
        if (open.size == 1) {
            $(document.body).addClass("openDialog");
        }
    },

    /**
     * Mark a popup as closed
     * @param id
     */
    remove: function(id) {
        open.delete(id);
        if (open.size == 0) {
            $(document.body).removeClass("openDialog");
        }
    }
}
